/**
 * This function is used on the anchor pages.
 * It gets the headings from the page's paragraph content,
 * extracts the ID and title text to populate the anchor menu.
 */
export const initAnchorMenu = () => {
  // Get the anchor menu <ul>
  const anchorMenu = document.getElementById('anchor-menu-list');
  // Check that the menu element exists.
  if (!anchorMenu) return;
  // Get all the headings with this class. Found in the "Heading" paragraph template
  const elements = document.getElementsByClassName('anchor-heading');

  Array.from(elements).forEach((item) => {
    // For each heading, get the id, and title text from its <h2> tag
    // const title = item.getElementsByClassName('anchor-heading-title')[0];
    // Only add anchors for H2 headings
    // Create the <li> element with the id, title and class, and append to anchor menu.
    const li = document.createElement('li');
    li.className = 'anchor-menu__link';

    const text = item.id;

    // Need to clean the text here to match the Heading ID and the
    // anchor ID. The other half of this is in
    // slugify_headings.module file in the custom module.
    const cleanText = text.replace(/[^a-zA-Z0-9-_\s]/, '');
    li.innerHTML = `<a href="#${cleanText}">${item.innerHTML}</a>`;
    anchorMenu.appendChild(li);

    // add event listener that will append the "show" class to the accordion title
    li.addEventListener('click', (e) => {
      const id = e.target.hash.substring(1);

      // Grab the h3 clicked
      const h3 = document.getElementById(id);

      // remove all show classes
      const titleContainers = Array.from(
        document.getElementsByClassName('accordion_link__container'),
      );

      titleContainers.forEach((titleContainer) => {
        titleContainer.classList.remove('show');
        titleContainer.querySelector('.accordion_link__header').setAttribute('aria-expanded', 'false');
      });

      // traverse up the DOM to find the parent to add 'show' too
      const accordion = h3.closest('.accordion_link__container');
      if (accordion) {
        accordion.classList.toggle('show');
        accordion.querySelector('.accordion_link__header').setAttribute('aria-expanded', 'true');
      }
    });
  });

  window.addEventListener('load', () => {
    const anchorMenuHeight = document.getElementById('anchor-menu-list').offsetHeight;
    const viewportHeight = document.documentElement.clientHeight;
    if (anchorMenuHeight > viewportHeight) {
      document
        .getElementsByClassName('anchor-menu')[0]
        .classList.toggle('sticky-bottom');
    }
  });

  window.addEventListener('resize', () => {
    const anchorMenuHeight = document.getElementById('anchor-menu-list').offsetHeight;
    const viewportHeight = document.documentElement.clientHeight;

    if (anchorMenuHeight > viewportHeight) {
      document
        .getElementsByClassName('anchor-menu')[0]
        .classList.toggle('sticky-bottom');
    }
  });
};

export default initAnchorMenu;
